import(/* webpackMode: "eager" */ "/home/ucraft/ucraft-next/src/app/[workspace]/[locale]/[appAlias]/loading.tsx");
